const creationError = {
  message: 'Sorry, there was an error creating your project. Please try again later.',
  severity: 'error',
  duration: 3000,
};

export { creationError };
